<template lang="html">
   <div class="textarea">
      <textarea  
         class="form-control"
         :id="action+name"
         :rows="rows"
         :placeholder="placeholder"
         :value="model"
         @input="updateSelf($event.target.value)">
      </textarea>
   </div>
</template>

<script>
export default {
   props: {
      name: {
         default: ''
      },
      rows: {
         default: 3
      },
      model: {
         default: ''
      },
      action: {
         default: ''
      },
      placeholder: {
         default: undefined
      }
   },
   methods: {
      updateSelf(model) {
         this.$emit("input", model);
      }
   },
}
</script>

<style lang="less"></style>